module.exports = __webpack_public_path__ + "static/media/powered-by.58d518cd.png";